
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DivisionsEditForm.html?raw';
//import { VAM2types, VAMclassNames } from "../../../_loadingHelpers/VAMv2";
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import HintBox from '../../../../moreCore/UI/EntityBased/HintBox/HintBox';
import Edit from '../../../../moreCore/UI/Edit/Edit';
import SelectBox from '../../../../moreCore/UI/SelectBox/SelectBox';
import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import { AddressTypes } from "../../../_loadingHelpers/Address";
import { ToasterHelpers } from "../../../../more/Helpers";

class DivisionsEditForm extends compose(_StatefulSection) {
    templateString: any = template;

    isNewDivision: boolean = false;
    organizationId: string = null;

    name: MdsLax<InstanceType<typeof Edit>>;
    address_sync_type: MdsLax<InstanceType<typeof SelectBox>>;
    superior_division: MdsLax<InstanceType<typeof SelectBox>>;
    sync_address: MdsLax<InstanceType<typeof HintBox>>;
    street: MdsLax<InstanceType<typeof Edit>>;
    postalCode: MdsLax<InstanceType<typeof HintBox>>;
    city: MdsLax<InstanceType<typeof HintBox>>;
    country: MdsLax<InstanceType<typeof HintBox>>;

    addressSection: HTMLElement;
    superiorDivisionSection: HTMLElement;
    syncAddressSection: HTMLElement;

    entity: AddressTypes.Division;
    addressSyncPresetValue: any = null;
    superiorDivisionPresetValue: any = null;
    dlg: MdsLax<InstanceType<typeof GenericDialog>>;

    _request: any = null;

    setupDivisionEditForm(isNew: boolean, entity: AddressTypes.Division, organizationId: string): void {

        this.isNewDivision = isNew;
        this.organizationId = organizationId;

        this.dlg = new GenericDialog();
        this.dlg.destroyOnClose = false;

        entity ? this.entity = entity : this.entity = <AddressTypes.Division>{};
        this.setData(this.entity);

        let divisionId: string = null;

        if (entity) {
            if (this.entity.ref_address_sync_type) this.addressSyncPresetValue = this.entity.ref_address_sync_type.ID;
            if (this.entity.ref_superior_division) this.superiorDivisionPresetValue = this.entity.ref_superior_division.ID;
            this.fillUpPostalCode();
            divisionId = entity.ID;
        }

        this.loadOtherDivisionsForOrganization(divisionId, this.organizationId);

        this.dlg.enableContentOverflow(true);

        this.dlg.show(this,
            this.entity ? this.entity.name : this.translations["AddressWizard__newDivision"],
            null,
            null,
            "saveclose",
            lang.hitch(this, this._onSaveCloseDlg)
        );
        this.dlg.disableButton("save");
        this.on("dirty", (isDirty) => {

            this.dlg.enableButton("save", isDirty);
        });
    }

    private fillUpPostalCode(): void {

        if (this.entity.ref_postal_code) {
            this.postalCode.setValue(this.entity.ref_postal_code, true);
            this.city.setValue(this.entity.ref_postal_code, true);
        } else {
            this.postalCode.setValue(this.entity.c_postal_code, true);
            this.city.setValue(this.entity.c_city, true);
        }
    }

    private _onSaveCloseDlg(action): void {

        console.debug("action", action);
        switch (action) {
            case 0:
                this.destroy();
                break;
            case 1:
                this._saveData();
                break;
            default:
        }
    }

    private _saveData(): void {

        let data = lang.clone(this.changedData) as AddressTypes.Division;

        this.StandbyStart();
        data["isNew"] = this.isNewDivision;
        data["organizationId"] = this.organizationId;
        data.ID = this.entity.ID;

        this._request = this.RequestManager.callfunction(
            "Webtool_API_AddressWizard__SaveDivisionData",
            data,
            lang.hitch(this, this._onSaveDataResponse),
            lang.hitch(this, this._onSaveDataError));
    }

    private _onSaveDataResponse(response): void {
        this._request = null;
        this.StandbyStop();

        this.emit("saved");
        this.showToast({
            title: this.translate("General_SavingSuccessful"),
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });
        this.destroy();
    }
    private _onSaveDataError(err): void {

        this._showErrorMessage(err);
        this.destroy();
    }

    _onChanged(key: string, value: any): void {

        switch (key) {
            case "name":
                if (!value) this.dlg.disableButton("save");
                 break;
            case "street":
            case "ref_country":
            case "ref_address_sync_type":
                this.adjustDataDisabledDataSections();
                this._checkData();
                break;
            case "c_postal_code":
                this._onValueChange_postalCode(value);
                break;
            case "c_city":
                this._onValueChange_city(value);
                break;
            case "ref_sync_address":
                break;
            case "ref_superior_division":
                this._checkData();
                break;
        }

        console.debug(this.id + " onchanged: " + key, this.changedData, this.currentData);
        console.debug("onchanged this.isDirty", this.isDirty())
    }

    private _checkData(): void {
        let syncType: AddressTypes.AddressSyncType = this.address_sync_type.selectedEntry?.entity;
        if (!syncType) return;

        let val = this.superior_division.getValue();

        if (!val && syncType.description == "vorgesetzter Abteilung") {

            this.UiModder.domClass.add(this.superior_division.errorMsgNode, "moreCore_ValidationMsgError")

            this.dlg.disableButton("save");
        } else {

            this.UiModder.domClass.remove(this.superior_division.errorMsgNode, "moreCore_ValidationMsgError")

            this.dlg.enableButton("save", this.isDirty());
        }


    //    if (val && syncType.description != "vorgesetzter Abteilung") {
    //        this.UiModder.domClass.remove(this.superior_division.errorMsgNode, "moreCore_ValidationMsgError")

    //        this.dlg.enableButton("save", this.isDirty());
    //    } else {
    //        this.UiModder.domClass.add(this.superior_division.errorMsgNode, "moreCore_ValidationMsgError")

    //        this.dlg.disableButton("save");
    //    }
    }

    private adjustDataDisabledDataSections(): void {
        let syncType: AddressTypes.AddressSyncType = this.address_sync_type.selectedEntry?.entity;
        if (!syncType) return;

        switch (syncType.description) {
            case "freie Eingabe":
                this.UiModder.domClass.remove(this.addressSection, "w3-hide");
                this.UiModder.domClass.add(this.syncAddressSection, "w3-hide");
                break;
            case "beliebiger Sync-Adresse":
                this.UiModder.domClass.add(this.addressSection, "w3-hide");
                this.UiModder.domClass.remove(this.syncAddressSection, "w3-hide");
                break;
            case "vorgesetzter Abteilung":
                this.UiModder.domClass.add(this.addressSection, "w3-hide");
                this.UiModder.domClass.add(this.syncAddressSection, "w3-hide");
                break;
            default:
                this.UiModder.domClass.add(this.addressSection, "w3-hide");
                this.UiModder.domClass.add(this.syncAddressSection, "w3-hide");
        }
    }

    private _onValueChange_postalCode(value: any): void {

        if (value != null && typeof value == "object") {

            this.city.setValue(value, true);
            this.country.setValue(value.ref_country, true);
        } else {

            if (this.city.getValue("entity")) this.city.setValue(null, true);
        }

        this.UiModder.domClass.toggle(this.country.domNode, "w3-disabled", typeof value != "string");

        //this._onValueChange(key, value);
    }

    private _onValueChange_city(value: any): void {

        if (value != null && typeof value == "object") {

            this.postalCode.setValue(value, true);
            this.country.setValue(value.ref_country, true);
        } else {

            if (this.postalCode.getValue("entity")) this.postalCode.setValue(null, true);
        }

        this.UiModder.domClass.toggle(this.country.domNode, "w3-disabled", typeof value != "string");
        //this._onValueChange(key, value);
    }

    private loadOtherDivisionsForOrganization(divisionId: string, organizationId: string): void {

        var url = window.appRoot + "AddressWizard/GetDivisionsInOrganizationList";
        //this.StandbyStart(this.superior_division.domNode);
        this.superior_division.StandbyStart()

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify({ divisionId: divisionId, organizationId: organizationId })
            },
            lang.hitch(this, this._onOtherDivisionsForOrganizationResponse),
            lang.hitch(this, this._showErrorMessage),
            false // sync
        );
    }

    private _onOtherDivisionsForOrganizationResponse(response: Array<AddressTypes.SuperiorDivision>): void {
        this.superior_division.StandbyStop();
        this.superior_division.setBlankOption("", "-- --", true);
        this.superior_division.setData(this.superiorDivisionPresetValue,
            response,
            "ID",
            "name",
            true
        );

        this.superior_division.constructOptions();
    }

    private loadAddressSyncTypes(): void {
        var url = window.appRoot + "AddressWizard/GetAddressSyncTypes";
        //this.StandbyStart(this.address_sync_type.domNode);
        this.address_sync_type.StandbyStart();

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onLoadAddressSyncTypesResponse),
            lang.hitch(this, this._showErrorMessage),
            false // sync
        );
    }

    private _onLoadAddressSyncTypesResponse(response: Array<AddressTypes.AddressSyncType>): void {
        this.address_sync_type.StandbyStop();
        this.address_sync_type.setBlankOption("", "-- --", true);
        this.address_sync_type.setData(this.addressSyncPresetValue,
            response,
            "ID",
            "description",
            true
        );

        this.address_sync_type.constructOptions();
        this.adjustDataDisabledDataSections();
    }

    private _showErrorMessage(err): void {

        this._showToastMessage(this.translate("General_Error"), err.Message, ToasterHelpers.ToasterIcons.error);
    }
    private _showToastMessage(title: string, msg: string, icon: ToasterHelpers.ToasterIcons): void {
        this.showToast({
            title: title,
            message: msg,
            iconClass: icon,
            timeout: 20000
        });
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.loadAddressSyncTypes();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DivisionsEditForm);